import React, { useEffect, useRef } from "react";

import cn from "classnames";
import { useTranslation } from "react-i18next";
import Typewriting from "react-typewriting";

import Search from "antd/lib/input/Search";

import { Inscription } from "../inscription";

import styles from "./styles.module.scss";

export interface SearcherProps {
  className?: string;
  loading?: boolean;
  placeholder?: string;
  examples?: string[];
  defaultValue?: string;
  onSearch: (value: string) => void;
}

export const Searcher: React.FC<SearcherProps> = (props) => {
  const timer = useRef<NodeJS.Timeout>();
  const { t } = useTranslation("searcher");
  const { onSearch, loading, defaultValue, placeholder, examples, className } = props;

  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  const handleChange = (value: string) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      onSearch(value);
    }, 800);
  };

  const processedExamples = (examples ?? []).map((example) => t("example", { example }));
  const typewritingOptions = [placeholder || t("placeholder") || "", ...processedExamples];

  return (
    <Inscription title={t("title")}>
      <Typewriting strings={typewritingOptions} waitBeforeDeleteMs={5000}>
        {({ currentText, fullCurrentText }) => (
          <Search
            loading={loading}
            disabled={loading}
            defaultValue={defaultValue}
            className={cn([styles.searcher, className])}
            placeholder={typewritingOptions.length === 1 ? fullCurrentText : currentText}
            onSearch={(value, _) => onSearch(value)}
            onChange={(event) => handleChange(event.target.value)}
          />
        )}
      </Typewriting>
    </Inscription>
  );
};
